   <script>
      import Layout from "../../layouts/auth";
      import appConfig from "@/app.config";

   /**
    * Login component
    */
    export default {
      page: {
         title: "Login",
         meta: [
         {
            name: "description",
            content: appConfig.description,
         },
         ],
      },
      components: {
         Layout,
      },
      data() {
         return {
            errors: {},
            mobile: '',
            password: '',    
            country_code: 1,
            country_codes:{},

            token: '',    
         };
      },
      mounted() {
         this.fetchCountryCodes();
      },
      methods: {

       numbersOnly(event) {
         let keyCode = event.keyCode;
         if (keyCode < 48 || keyCode > 57) {
            event.preventDefault();
         }
      }, 

      noSpaces(event) {
         let keyCode = event.keyCode;
         if(keyCode == 32) {
            event.preventDefault();
         } else {
            return;
         }
      },

      alphaSpacesOnly(event) {
         let keyCode = event.keyCode;
         if ((keyCode >= 65 && keyCode <= 90) || 
            (keyCode >= 97 && keyCode <= 122) ||               
            (keyCode == 32)) {
           return;
     } else {
      event.preventDefault();
   }
},

onSubmit() {
  
  var data = JSON.stringify({
   "country_code": this.country_code,
   "mobile": this.mobile,
   "password": this.password
});

           //console.log(data);
           const config = {
              headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
             },
          };

          this.errors = {};
          this.$axios
          .post("fuelstation/login/fuel_station", data, config)
          .then((response) => {
           if(response.status == 200) {
            console.log(response);
            var responseData = response.data.data.details;
            if (responseData.token) {

               localStorage.setItem('sigofuel_fuelstation', JSON.stringify(responseData));                  
               this.token = responseData.token;
               this.$router.push({ name: "dashboard" });
               this.$swal("", response.data.message, "success");        
               
            } else {
               this.$swal("", "Failed to fetch token, please try again", "error");
            }
            
         } else {
           this.$swal("", "Failedd to fetch token, please try again", "error");
        }
     })
          .catch((error) => {
            console.log(error);
            console.log(error.response);
            if (error.response) {
               if(error.response.status == 422) {               
                  if (error.response.data) {
                     this.errors = error.response.data.message;
                  } 
                  this.$swal("", error.response.statusText, "error");
                  
               } else if(error.response.status == 500) {
                  this.$swal("", error.response.statusText, "error");

               } else {
                  this.$swal("", "Something went wrong", "error");
               }
            } else {
               this.$swal("", error.message, "error");
            }
            
         }); },
          
          fetchCountryCodes() {
            const config = {
              headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
             },
          };
          let url = "fuelstation/get-countrycodes";         
          this.$axios
          .get(url, config)
          .then((res) => {
            var responseData = res.data.data;
            console.log(responseData);
            this.country_codes = responseData.country_codes;
            console.warn(responseData.country_codes);

         })
          .catch((err) => console.log(err));
       },


    },
 };
</script>

<template>
   <Layout>
      <div class="row justify-content-center">
         <div class="col-md-8 col-lg-6 col-xl-5">
            <div class="card overflow-hidden">
               <div class="bg-soft bg-primary">
                  <div class="row">
                     <div class="col-7">
                        <div class="text-primary p-4">
                           <h5 class="text-primary">FUEL STATION LOGIN</h5>
                           <p>Sign in to continue to SIGO FUEL</p>
                        </div>
                     </div>
                     <div class="col-5 align-self-end">
                        <img src="@/assets/images/profile-img.png" alt class="img-fluid"/>
                     </div>
                  </div>
               </div>
               <div class="card-body pt-0">
                  <div>
                     <router-link tag="a" to="/">
                        <div class="avatar-md profile-user-wid mb-4">
                           <span class="avatar-title rounded-circle bg-light">
                              <img src="@/assets/images/logo.png" alt height="60" />
                           </span>
                        </div>
                     </router-link>
                  </div>           

                  <b-form class="p-2" @submit.prevent="onSubmit">
                     
                     <b-form-group class="col-lg-12 mb-3">
                        <label>Mobile <span class="text-danger">*</span></label>
                        <b-input-group>
                           <b-input-group-prepend>
                              <select class="form-control" v-model="country_code">
                                 <option :value="country.id" v-for="country in country_codes" :key="country.id">{{country.country_code}}</option>
                              </select>
                           </b-input-group-prepend>
                           <b-form-input v-model="mobile" @keypress="numbersOnly" maxlength="70" v-bind:class="{ 'is-invalid': Boolean(errors.mobile) }"></b-form-input>
                           <div v-for="(val, index) in errors.mobile" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-input-group>

                        
                     </b-form-group>
                     <b-form-group class="mb-3" id="input-group-2" label="Password" label-for="input-2">
                        <b-form-input id="input-2" v-model="password" type="password" placeholder="Enter password" :class="{ 'is-invalid': Boolean(errors.password)  }"></b-form-input>

                        <div v-for="(val, index) in errors.password" :key="index" class="invalid-feedback">
                           <p class="mb-0">{{ val }}</p>
                        </div>   
                     </b-form-group>
                     
                     <div class="mt-3 d-grid">
                        <b-button type="submit" variant="primary" class="btn-block">Log In</b-button>
                     </div>
                  </b-form>
               </div>
               <!-- end card-body -->
            </div>
            <!-- end card -->

            <div class="mt-5 text-center">
             
               <p>
                  © {{ new Date().getFullYear() }} SIGO FUEL. Powered by Sigosoft
               </p>
            </div>
            <!-- end row -->
         </div>
         <!-- end col -->
      </div>
      <!-- end row -->
   </Layout>
</template>

<style lang="scss" module></style>